<template>
    <div v-if="registration.id">
        <card-header title="Refund/Delete Registration" icon="fa-times"></card-header>

        <card-body>
            <card-list>
                <container-list-item padded>
                    <div class="columns">
                        <div class="column is-narrow">
                            <i class="fas fa-info-circle"></i>
                        </div>
                        <div class="column pr-5">
                            <section v-if="registration.payment_type === 'cc'">
                                This registration was paid by credit card and will be automatically refunded when deleted. <strong>This is a permanent action</strong>
                            </section>
                            <section v-else>
                                This registration was not paid by credit card and will not be automatically refunded.  You may delete this registration if you wish.  <strong>This is a permanent action</strong>.
                            </section>
                        </div>
                    </div>
                </container-list-item>
                <separator-list-item></separator-list-item>

                <data-row title="Full Name">
                    <span class="clickable" @click="$copyText(registration.users.first_name + ' ' + registration.users.last_name)">{{registration.users.first_name}} {{registration.users.last_name}}</span>
                </data-row>
                <data-row title="Type">{{registration.conf_reg_types.title}}</data-row>
                <data-row title="Date">{{registration.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                <data-row title="Payment">
                    <span v-if="registration.payment_type === 'cc'">{{registration.total_paid | currency}} by Credit Card</span>
                    <span v-if="registration.payment_type === 'po'">{{registration.total_paid | currency}} by Purchase Order</span>
                </data-row>

            </card-list>

        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <!--                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteType"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Type?</span></b-button>-->
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-danger"
                        size="is-small"
                        @click="deleteRegistration"
                    ><i class="fas fa-times mr-2"></i><span v-if="registration.payment_type === 'cc'">Refund & </span>Delete Registration
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>
<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../../components/tiles/ConferenceTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import CardFooter from "../../../TIER/components/CardFooter.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardFooter, ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                registration: {}
            };
        },
        methods: {
            loadRegistration: function(force) {
                this.$emit('loading', true);
                http.get('registrations/' + this.props.regId, {force}).then(response => {
                    this.registration = response.data;
                    this.$emit('loading', false);
                });
            },
            deleteRegistration: function() {
                http.delete(`registrations/${this.props.regId}`).then(response => {
                    this.loadRegistration(true);
                    this.$closeCard(this.card);
                    this.$reloadCard('registration', {regId: this.props.regId});
                    this.$reloadCard('registrations', {confId: this.props.confId});
                    this.$reloadCard('conference', {confId: this.props.confId});
                });
            }
        },
        computed: {

        },
        watch: {

        },
        mounted: function() {
            this.loadRegistration();
        }
    };
</script>

